import { combineReducers } from 'redux'
import {
    data,
    status,
    secondaryStatus,
    routeId,
    teamId,
    isFetching,
    fourohfour,
    trackerUnavailable,
    ads,
    sectionTitle,
    isMobileApp,
    mobileDevice,
    summaryVideo,
    ticker,
    navMenuCollapsed,
    location,
    soccerLeagueOrder,
    juniorsLeagueOrder,
} from './shared_reducers'
import { mlbLivetracker } from './mlb_livetracker_reducers'
import { nhlLivetracker } from './nhl_livetracker_reducers'

/**********
COMBINE ALL REDUCERS
**********/

const appReducer = combineReducers({
    data,
    status,
    secondaryStatus,
    routeId,
    teamId,
    isFetching,
    fourohfour,
    trackerUnavailable,
    isMobileApp,
    location,
    mobileDevice,
    ads,
    sectionTitle,
    summaryVideo,
    ticker,
    navMenuCollapsed,
    mlbLivetracker,
    nhlLivetracker,
    soccerLeagueOrder,
    juniorsLeagueOrder,
})

const rootReducer = (state, action) => {
    // master app state clearing technology if ya need it
    if (action.type === 'CLEAR_STATE') {
        state = {}
    }
    return appReducer(state, action)
}

export default rootReducer
